/**
 * 处理输入框弹起输入法被遮挡问题
 * 如果在Vue项目中，建议只在根节点App.vue mounted中使用处理
 * @param {VueComponent} vm Vue根实例
 */
function handleInputMask(vm) {
  // 判断只在vue根元素中设置
  if (vm && (!vm.$el || vm.$el !== vm.$root.$el)) {
    console.warn('handlerInputMask 尝试在非根节点应用，重新影响当前项目整体输入框');
  }
  // 标记已处于输入
  var isInput = false;
  // resize标记是否 输入法引起
  var isResizeDueToInput = false;
  // 用于填充的元素
  var fillDomName = 'is-input-fill_dom';
  var fillDom = document.createElement('div');
  fillDom.setAttribute('class', fillDomName);
  fillDom.setAttribute('name', fillDomName);
  fillDom.style.height = '50vh';
  fillDom.style.flexShrink = 0; // 防止body设置弹性布局被压缩
  // document.body.appendChild(fillDom);
  // 活跃输入框
  var activeElement = null;
  // 用于输入框blur事件处理
  var onBlur = () => {
    isInput = false;
    var search = document.body.children.namedItem(fillDomName);
    search && document.body.removeChild(fillDom);
    if (activeElement) {
      activeElement.removeEventListener('blur', onBlur);
    }
    activeElement = null;
  };
  // 当前检验的活跃元素 input、textarea输入框
  var checkNodeNames = ['INPUT', 'TEXTAREA'];
  document.addEventListener('click', () => {
    activeElement = document.activeElement;
    // input、textarea等元素点击时，先触发focus事件，再触发click事件并冒泡至document（如果冒泡被上层元素阻止，可通过document.dispathEvent触发点击）
    if (checkNodeNames.includes(activeElement.nodeName)) {
      // 主函数
      if (isInput || isResizeDueToInput) return;
      isInput = true;
      document.body.appendChild(fillDom);
      // 增加填充元素后将输入框置于可视区域中间
      activeElement.scrollIntoView({ block: 'center' });
      activeElement.addEventListener('blur', onBlur);
    }
  });
  window.addEventListener('resize', () => {
    var ele = document.activeElement;
    if (checkNodeNames.includes(ele.nodeName)) {
      // 通过window.onresize事件，判断输入框弹起是否是顶起窗口。
      // 如果是顶起窗口，触发resize事件，则需要删除填充元素；如果不是顶起窗口，不触发resize事件，以下代码不执行
      var search = document.body.children.namedItem(fillDomName);
      search && document.body.removeChild(fillDom);
      isResizeDueToInput = true;
    } else {
      isResizeDueToInput = false;
    }
  });
}

export default handleInputMask;



// WEBPACK FOOTER //
// ./src/utils/handler/handleInputMask.js